import { translate } from "../../../util/translate"

export const priceTableHeaders = [
  {
    text: translate['vendors.label.title'],
    value: 'vendor',
  },
  {
    text: translate['item.label.createdAt'],
    value: 'date_created',
  },
  { value: 'actions', align: 'end', width: '100' },
  { text: '', align: 'end', value: 'data-table-expand' },
]

export const priceTableSubItemHeaders = [
  {
    text: translate['priceTable.table.name'],
    value: 'item.name',
    width: 400,
  },
  {
    text: translate['priceTable.table.category'],
    value: 'item.category.name',
    width: 200,
  },
  {
    text: translate['priceTable.table.basePrice'],
    value: 'base_price',
    width: 200,
  },
  {
    text: translate['priceTable.table.comboPrice'],
    value: 'combo_price',
    width: 200,
  },
  {
    value: 'actions',
    align: 'end',
    width: 100,
  },
]
